<template>
  <div style="background-color: #E6ECF0;">
    <Loader />
    <Header parameters="adminDashboard" :window="window" />
    <div
      :class="this.window.width < 480 ? 'container-fluid' : 'container'"
      align="center"
    >
      <!--<ButtonDashboardList />-->
      <div v-if="this.$route.params.type === 'resultatGroup'">
        <ButtonListUsers
          :url_moderateur="this.$route.params.url_moderateur"
          :insightName="insightName"
        />
        <AdminRoue v-if="!this.button_renduListeTrigramme" />
        <AdminParticipantsTrigrammes v-if="this.button_renduListeTrigramme" />
      </div>
      <div
        v-if="
          this.$route.params.type === 'resultatIndividual' &&
            this.insight_resultats_copy
        "
      >
        <AdminListeParticipants :url_moderateur="this.$route.params.url_moderateur" />
      </div>
    </div>
    <Footer :window="window" />
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Footer from "@/components/layout/Footer";
import Loader from "@/components/insight/Utils/Loader";
import Header from "@/components/layout/Header";
import ButtonListUsers from "@/components/insight/Buttons/ButtonListUsers";
import ButtonDashboardList from "@/components/insight/Buttons/ButtonDashboardList";
import AdminRoue from "@/components/insight/PageDashboard/AdminRoue";
import AdminParticipantsTrigrammes from "@/components/insight/PageDashboard/AdminParticipantsTrigrammes";
import AdminListeParticipants from "@/components/insight/PageDashboard/AdminListeParticipants";
import EventBus from "../../eventBus";

export default {
  components: {
    Footer,
    Loader,
    Header,
    ButtonListUsers,
    ButtonDashboardList,
    AdminRoue,
    AdminListeParticipants,
    AdminParticipantsTrigrammes,
  },
  mounted() {
    this.$nextTick(() => {
      this.handleResize();
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  data() {
    return {
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: "asc",
      url_insight: process.env.VUE_APP_URL_SSO_FRONT,
      url_moderateur: this.$route.params.url_moderateur,
      profil: [],
      colors: [],
      insight_id: "",
      insightName: "",
      arrayGotResults: [],
      room: "",
      errors: [],
      id_affichage_resultats: 0,
      arrayReponses: ["test"],
      cancelText: this.$i18n.t("button.annuler"),
      confirmText: this.$i18n.t("button.supprimer"),
      message: this.$i18n.t("insight.participant.supprimer"),
      window: {
        width: window.innerWidth,
      },
    };
  },
  created() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    EventBus.$on("delete_id_participant", this.delete_participant);
    EventBus.$on("calcul_pts_color_checkbox", this.PtsColors);
    EventBus.$on("ImportExportaddIds", this.addIds);
    this.$store.commit("IS_LOADING_RESULTATS");
    axios.defaults.headers.common["urlmoderateur"] = this.url_moderateur;
    axios
      .get(process.env.VUE_APP_URL_SSO_API + "insight/resultats")
      .then((response) => {
        this.insight_id = response.data.insight.id;
        this.room = "Room_Insight_" + response.data.insight.id;
        this.insightName = response.data.insight.name;
        this.insight_id = response.data.insight.id;
        this.$socket.emit("room", this.room);
        let resultats = response.data.resultats;
        this.$store.commit("INSIGHT_ADMIN_DATA", resultats);
        this.$store.commit("INSIGHT_ADMIN_DATA_COPY", resultats);
        let participants_termine = response.data.resultats.filter(
          (x) => x.profil !== null
        );
        this.addIds(participants_termine);
        this.$store.commit(
          "INSIGHT_EN_COURS_PAGE_ADMIN",
          response.data.insight
        );
        this.$store.commit("IS_NOT_LOADING_RESULTATS");
        this.$store.commit(
          "INSIGHT_CHECKROWS_PARTICIPANTS",
          participants_termine
        );
        this.$store.commit(
          "INSIGHT_ADMIN_PARTICIPANTS_TERMINE",
          participants_termine
        );
        this.PtsColors("PtsColorsGlobale");
        this.PtsColors("PtsColorsCheckboxs");
        this.profileExtented(participants_termine);
        this.sendResults(participants_termine);
        EventBus.$emit("checkrows");
      })
      .catch((error) => {
        this.errors.push(error);
        this.$buefy.toast.open({
          message: "Une erreur s'est produite",
          type: "is-danger",
        });
      });
  },
  computed: {
    ...mapGetters([
      "insight_resultats",
      "insight_nb_participants",
      "nb_participants_en_attente",
      "array_participants_termine",
      "button_renduDashBoard",
      "button_renduListe",
      "button_renduRoue",
      "button_renduListeTrigramme",
      "insight_checkrows_participants",
      "TotalParticipantPts",
      "insight_resultats_copy",
      "insight_en_cours",
    ]),
  },
  methods: {
    sendMessageToParent(taskToDo) {
      let message = {
        task: taskToDo,
      };
      window.top.postMessage(message, "*");
    },
    handleResize() {
      let message = {
        height: document.body.scrollHeight,
      };
      window.top.postMessage(message, "*");
      this.window.width = window.innerWidth;
    },
    addIds(participants_termine) {
      this.id_affichage_resultats = 0;
      participants_termine
        .filter((x) => x.finish !== 0)
        .sort((a, b) => a.lastname.localeCompare(b.lastname))
        .map((el) => {
          el.id_affichage_resultats = this.id_affichage_resultats =
            this.id_affichage_resultats + 1;
        });
    },
    // permet de calculer les pastilles de couleurs des participants
    profileExtented(reponse) {
      for (let i = 0; i < reponse.length; i++) {
        let profilExtended = [];
        let colors = [
          reponse[i].color1,
          reponse[i].color2,
          reponse[i].color3,
          reponse[i].color4,
        ];
        let max = [];
        max[0] = -1;
        for (let j = 0; j < colors.length; j++) {
          if (max[0] < colors[j]) {
            max = [];
            max[0] = colors[j];
            profilExtended = [];
            profilExtended[0] = j;
          } else if (max[0] === colors[j]) {
            max.push(colors[j]);
            profilExtended.push(j);
          }
        }
        reponse[i].profilExtended = profilExtended;
      }
      reponse.forEach((participant) => {
        if (typeof participant.profil === "string") {
          participant.profil = JSON.parse(participant.profil);
        } else {
          return false;
        }
      });
      this.$store.commit("INSIGHT_ADMIN_PARTICIPANTS_TERMINE", reponse);
    },
    // calcule des points par profils dominants et par points par groupe (soit avec les checkboxs, soit globale)
    PtsColors(reponse) {
      let array_reponse = [];
      if (reponse === "PtsColorsGlobale") {
        array_reponse = this.array_participants_termine;
      } else if (reponse === "PtsColorsCheckboxs") {
        array_reponse = this.insight_checkrows_participants;
      } else {
        return false;
      }
      let functionTotalParticipantPts = [0, 0, 0, 0];
      for (let i = 0; i < array_reponse.length; i++) {
        let array = [];
        array = [
          array_reponse[i].color2,
          array_reponse[i].color1,
          array_reponse[i].color4,
          array_reponse[i].color3,
        ];
        for (let x = 0; x < array.length; x++) {
          if (array[0] !== null) functionTotalParticipantPts[x] += array[x];
        }
      }
      let functionTotalParticipantColor = [0, 0, 0, 0];
      const tabColorsTest = [1, 0, 3, 2];
      for (let y = 0; y < array_reponse.length; y++) {
        for (let v = 0; v < tabColorsTest.length; v++) {
          for (let j = 0; j < tabColorsTest.length; j++) {
            if (array_reponse[y].profil !== null) {
              if (array_reponse[y].profil[0][j] === tabColorsTest[v])
                functionTotalParticipantColor[v] += 1;
            }
          }
        }
      }
      if (reponse === "PtsColorsGlobale") {
        this.$store.commit(
          "INSIGHT_TOTAL_PARTICIPANTS_PTS",
          functionTotalParticipantPts
        );
        this.$store.commit(
          "INSIGHT_TOTAL_PARTICIPANTS_COLOR",
          functionTotalParticipantColor
        );
      } else if (reponse === "PtsColorsCheckboxs") {
        this.$store.commit(
          "INSIGHT_TOTAL_PARTICIPANTS_PTS_CHECKBOXS",
          functionTotalParticipantPts
        );

        this.$store.commit(
          "INSIGHT_TOTAL_PARTICIPANTS_COLOR_CHECKBOXS",
          functionTotalParticipantColor
        );
      } else {
        return false;
      }
    },
    // envois des datas dans 'circles' pour calculer les coordonnees dans la roue
    sendResults() {
      let test = this.insight_checkrows_participants;
      test = test.sort(function(a, b) {
        return a.id_affichage_resultats - b.id_affichage_resultats;
      });

      EventBus.$emit("got-results", test);
    },
    // permet de supprimer un participant
    delete_participant(id) {
      this.$buefy.dialog.confirm({
        cancelText: this.cancelText,
        confirmText: this.confirmText,
        message: this.message,
        onConfirm: () => {
          axios.defaults.headers.common["urlmoderateur"] = this.url_moderateur;
          axios
            .delete(process.env.VUE_APP_URL_SSO_API + "insight/resultats/" + id)
            .then((response) => {
              this.arrayReponses.push(response);
              this.addIds(this.arrayReponses);
              this.$store.commit(
                "INSIGHT_ADMIN_DATA",
                this.insight_resultats.filter((x) => x.id != id)
              );
              this.$store.commit(
                "INSIGHT_ADMIN_DATA_COPY",
                this.insight_resultats.filter((x) => x.id != id)
              );
              this.$store.commit(
                "INSIGHT_ADMIN_PARTICIPANTS_TERMINE",
                this.insight_resultats.filter(
                  (x) => x.id != id && x.profil !== null
                )
              );
              this.$store.commit(
                "INSIGHT_CHECKROWS_PARTICIPANTS",
                this.insight_resultats.filter(
                  (x) => x.id != id && x.profil !== null
                )
              );
              this.PtsColors("PtsColorsGlobale");
              this.PtsColors("PtsColorsCheckboxs");
              this.$buefy.toast.open({
                type: "is-success",
                message: "Suppression",
              });
            })
            .catch((error) => {
              this.errors.push(error);
            });
        },
      });
    },
  },
  sockets: {
    connect() {
      if (this.insight_id) {
        this.room = "Room_Insight_" + this.insight_id;
        this.$socket.emit("room", this.room);
      }
    },
    channel(data) {
      data = JSON.parse(decodeURIComponent(data));
      if (data.type == "NEW_PARTICIPANT") {
        data.reponse.profil = JSON.parse(data.reponse.profil);
        let arrayInscrit = this.insight_resultats;
        let arrayTermine = this.insight_resultats;
        arrayInscrit.push(data.reponse);
        this.$store.commit("INSIGHT_ADMIN_DATA", arrayInscrit);
        this.$store.commit("INSIGHT_ADMIN_DATA_COPY", arrayTermine);
        this.$store.commit("INSIGHT_CHECKROWS_PARTICIPANTS", arrayTermine);
        // si un import/export on recharge la liste des inscrits et des terminés dans le store
        arrayTermine.filter((x) => x.profil !== null);
        this.addIds(arrayTermine);
        this.$store.commit("INSIGHT_ADMIN_PARTICIPANTS_TERMINE", arrayTermine);
      }
      if (data.type == "UPDATE_PARTICIPANT") {
        data.reponse.profil = JSON.parse(data.reponse.profil);
        let arrayTermine = this.insight_resultats;
        let index = arrayTermine.findIndex(
          (resultats) => resultats.id === data.reponse.id
        );
        arrayTermine.splice(index, 0, data.reponse);
        arrayTermine.splice(index + 1, 1);
        arrayTermine.filter((x) => x.profil !== null);
        this.$store.commit("INSIGHT_ADMIN_PARTICIPANTS_TERMINE", arrayTermine);
        this.$store.commit("INSIGHT_ADMIN_DATA", arrayTermine);
        this.$store.commit("INSIGHT_ADMIN_DATA_COPY", arrayTermine);
        this.$store.commit("INSIGHT_CHECKROWS_PARTICIPANTS", arrayTermine);
        this.PtsColors("PtsColorsGlobale");
        this.PtsColors("PtsColorsCheckboxs");
        this.profileExtented(arrayTermine);
        EventBus.$emit("got-results", arrayTermine);
        EventBus.$emit("updateparticipantcheckrow");
        this.addIds(arrayTermine);
      }
      if (data.type == "DELETE_PARTICIPANT") {
        let arrayTermine = this.insight_resultats;
        for (var i = 0; i < arrayTermine.length; i++) {
          if (arrayTermine[i].id === data.reponse.id) {
            arrayTermine.splice(i, 1);
            i--;
          }
        }
        arrayTermine.filter((x) => x.profil !== null);
        this.$store.commit("INSIGHT_ADMIN_PARTICIPANTS_TERMINE", arrayTermine);
        this.$store.commit("INSIGHT_ADMIN_DATA", arrayTermine);
        this.$store.commit("INSIGHT_ADMIN_DATA_COPY", arrayTermine);
        this.$store.commit("INSIGHT_CHECKROWS_PARTICIPANTS", arrayTermine);
        this.PtsColors("PtsColorsGlobale");
        this.PtsColors("PtsColorsCheckboxs");
        this.profileExtented(arrayTermine);
        this.addIds(arrayTermine);
      }
    },
  },
  beforeDestroy() {
    this.room = "Room_Insight_" + this.insight_id;
    this.$socket.emit("leave_room", this.room);
    EventBus.$off("delete_id_participant");
  },
};
</script>
